import { Container, Graphics } from 'pixi.js';

interface Zone { x: number; y: number; r: number; life: number; view: Graphics; }

// Periodic ×2 score-multiplier zones — gold rings spawn ~30s apart on non-boss waves.
// Player standing inside any zone returns scoreMul=2; otherwise 1. Zones live ~6s and fade out.
export class ScoreZones {
  private zones: Zone[] = [];
  private timer = 0;
  private layer: Container;

  constructor(layer: Container) {
    this.layer = layer;
  }

  tick(dt: number, allowSpawn: boolean, px: number, py: number, W: number, H: number): number {
    if (allowSpawn) {
      this.timer += dt;
      if (this.zones.length === 0 && this.timer > 30) {
        this.timer = 0;
        this.spawn(W, H);
      }
    }
    let scoreMul = 1;
    for (let i = this.zones.length - 1; i >= 0; i--) {
      const z = this.zones[i];
      z.life -= dt;
      const fade = z.life > 1 ? 0.7 : z.life * 0.7;
      z.view.alpha = fade;
      const dx = px - z.x, dy = py - z.y;
      if (dx * dx + dy * dy < z.r * z.r) scoreMul = 2;
      if (z.life <= 0) {
        z.view.parent?.removeChild(z.view);
        z.view.destroy();
        this.zones.splice(i, 1);
      }
    }
    return scoreMul;
  }

  private spawn(W: number, H: number): void {
    const ring = new Graphics();
    // Outer halo
    ring.circle(0, 0, 96);
    ring.fill({ color: 0xffdd00, alpha: 0.06 });
    ring.circle(0, 0, 88);
    ring.fill({ color: 0xffdd00, alpha: 0.10 });
    // Main ring (double stroke for chromatic look)
    ring.circle(0, 0, 80);
    ring.stroke({ width: 4, color: 0xffdd00, alpha: 0.85 });
    ring.circle(0, 0, 76);
    ring.stroke({ width: 2, color: 0xffffaa, alpha: 0.65 });
    // Inner accent ring
    ring.circle(0, 0, 30);
    ring.stroke({ width: 1.5, color: 0xffdd00, alpha: 0.45 });
    // Center dot
    ring.circle(0, 0, 4);
    ring.fill({ color: 0xffffff, alpha: 0.9 });
    ring.x = W * 0.3 + Math.random() * W * 0.4;
    ring.y = H * 0.3 + Math.random() * H * 0.4;
    this.layer.addChild(ring);
    this.zones.push({ x: ring.x, y: ring.y, r: 80, life: 6, view: ring });
  }
}
